import { render, staticRenderFns } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=7ecc8255&scoped=true&"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc8255",
  null
  
)

export default component.exports